import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ReactComponent as BrandLogo } from "../assets/logos/logo-colors-2.svg";
import { ReactComponent as BrandLogo2 } from "../assets/logos/logo-brand.svg";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import InfoIcon from "@mui/icons-material/Info";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import ArticleIcon from "@mui/icons-material/Article";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const menuItems = [
    { label: "Agenda", route: "/agenda", icon: <MenuBookIcon /> },
    {
      label: "About IGI",
      route: "/about-igi",
      icon: <AccountBalanceIcon />,
    },
    { label: "Speakers", route: "/speakers", icon: <RecordVoiceOverIcon /> },
    { label: "Partners", route: "/partners", icon: <LocationOnIcon /> },
    { label: "Latest News", route: "/latestnews", icon: <ContactMailIcon /> },
    {
      label: "Publications & Reports",
      route: "/publications",
      icon: <ArticleIcon />,
    },
    { label: "About Us", route: "/about", icon: <InfoIcon /> },
  ];

  const toggleMenu = () => setIsOpen((prev) => !prev);
  const closeMenuOnMobile = () => {
    if (window.innerWidth < 1024) setIsOpen(false);
  };

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
    return () => (document.body.style.overflow = "auto");
  }, [isOpen]);

  useEffect(() => {
    // Close menu on route change (especially mobile)
    closeMenuOnMobile();
  }, [location]);

  return (
    <header className="w-full container overflow-y-hidden bg-brandBlue font-outfit relative flex justify-between items-center py-[1.75rem] px-[2rem] xxs:px-[3rem]">
      <Link to="/" className=" z-[10] flex items-center">
        <BrandLogo className="w-[170px] h-[50px] xxs:w-[120px] transform scale-[9.5] " />
      </Link>

      <button
        onClick={toggleMenu}
        className="absolute z-[30] top-[1.5rem] right-[1.5rem] lg:hidden flex items-center justify-center"
        aria-label="Toggle menu"
      >
        {isOpen ? (
          <div className="flex items-center justify-center bg-[#09d0be] text-brandBlue rounded-2xl p-2 shadow-md">
            <CloseIcon sx={{ fontSize: 30 }} />
          </div>
        ) : (
          <MenuIcon sx={{ fontSize: 45, color: "#ffffff" }} />
        )}
      </button>

      {/* Navigation */}
      <nav className="relative z-[29]">
        <div
          className={`lg:hidden fixed inset-0 bg-brandBlue transition-opacity duration-300 ${
            isOpen
              ? "opacity-100 pointer-events-auto z-[20]"
              : "opacity-0 pointer-events-none"
          }`}
        ></div>
        <ul
          className={`flex flex-col lg:flex-row items-center gap-8 uppercase text-[15px] font-bold transition-transform duration-300 ${
            isOpen ? "translate-x-0 !items-start pt-[2rem]" : "translate-x-full"
          } fixed top-0 right-0 w-full h-full bg-[#DAF4F1] text-brandBlue z-[30]  px-10 lg:static lg:translate-x-0 lg:h-auto lg:w-auto lg:bg-transparent lg:text-white lg:p-0`}
        >
          {isOpen ? (
            <BrandLogo2 className="w-[170px] z-[-1] lg:hidden h-[50px] xxs:w-[120px] transform scale-[9.5] " />
          ) : (
            ""
          )}
          {menuItems.map((item) => (
            <li
              key={item.label}
              className="flex items-center gap-3 hover:text-softGreen"
            >
              {item.external ? (
                <a
                  href={item.route}
                  className="flex items-center gap-3"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={closeMenuOnMobile}
                >
                  <span className="lg:hidden">{item.icon}</span>
                  {item.label}
                </a>
              ) : (
                <Link
                  to={item.route}
                  className="flex items-center gap-3"
                  onClick={closeMenuOnMobile}
                >
                  <span className="lg:hidden">{item.icon}</span>
                  {item.label}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default Header;
